(() => {
  const DESKTOP_QUERY = '(min-width: 1000px)';
  const COLLAPSED_CLASS = 'header__primary-nav--collapsed';

  const setup = (nav) => {
    if (nav.dataset.navFit === 'true') return;
    nav.dataset.navFit = 'true';

    const list = nav.querySelector(':scope > ul');
    if (list == null) return;

    const desktop = window.matchMedia(DESKTOP_QUERY);

    const requiredWidth = () => {
      const items = Array.from(list.children);
      if (items.length === 0) return 0;

      const gap = parseFloat(getComputedStyle(nav).columnGap) || 0;
      const links = items.reduce((total, item) => total + item.getBoundingClientRect().width, 0);

      return links + gap * (items.length - 1);
    };

    const update = () => {
      if (!desktop.matches) {
        nav.classList.remove(COLLAPSED_CLASS);
        return;
      }

      nav.classList.remove(COLLAPSED_CLASS);

      const fits = requiredWidth() <= nav.clientWidth - 1;

      nav.classList.toggle(COLLAPSED_CLASS, !fits);
    };

    const container = nav.closest('.header') || nav.parentElement;
    new ResizeObserver(update).observe(container);

    desktop.addEventListener('change', update);

    if (document.fonts != null) document.fonts.ready.then(update);

    update();
  };

  const init = (root) => root.querySelectorAll('.header__primary-nav').forEach(setup);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
